import React, { useState } from 'react';
import { CircularProgress, TextField } from '@mui/material';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import CssBaseline from '@mui/material/CssBaseline';
import Grid from '@mui/material/Grid';
import Link from '@mui/material/Link';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import { makeStyles } from '@mui/styles';

import { Navigate } from 'react-router-dom';
import logoImg from '../../assets/logo.png';
import ResponsiveDialog from '../../components/molecules/responsiveDialog';
import { useAuth } from '../../hooks/auth';

function Copyright() {
  return (
    <Typography variant='body2' color='textSecondary' align='center'>
      {'Copyright © '}
      <Link color='inherit' href='https://www.umatch.com.br'>
        Umatch
      </Link>{' '}
      {new Date().getFullYear()}.
    </Typography>
  );
}

const useStyles = makeStyles(theme => ({
  root: {
    height: '100vh',
  },
  image: {
    backgroundImage:
      'url(https://images.unsplash.com/photo-1489844097929-c8d5b91c456e?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=752&q=80)',
    backgroundRepeat: 'no-repeat',
    backgroundColor: theme.palette.mode === 'dark' ? theme.palette.grey[900] : theme.palette.grey[50],
    backgroundSize: 'cover',
    backgroundPosition: 'center',
  },
  paper: {
    margin: theme.spacing(8, 4),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },

  submit: {
    margin: theme.spacing(3, 0, 2),
  },
}));

export function Login() {
  const classes = useStyles();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [isErrorDialogOpen, setIsErrorDialogOpen] = useState(false);

  const { user, signIn } = useAuth();

  const handleSignIn = async () => {
    try {
      setLoading(true);
      await signIn({ username, password });
    } catch (error) {
      setLoading(false);
      setIsErrorDialogOpen(true);
    }
  };

  const handleChangeUser = event => {
    const { value } = event.target;
    setUsername(value);
  };

  const handleChangePassword = event => {
    const { value } = event.target;
    setPassword(value);
  };

  if (user) {
    return <Navigate to='/' replace />;
  }

  return (
    <Grid container component='main' className={classes.root}>
      <ResponsiveDialog
        open={isErrorDialogOpen}
        handleClose={() => setIsErrorDialogOpen(false)}
        title='Você não tem acesso ao Uadmin'
        content='Verifique se digitou o usuário e senha corretos'
      />
      <CssBaseline />
      <Grid item xs={false} sm={4} md={7} className={classes.image} />
      <Grid item xs={12} sm={8} md={5} component={Paper} elevation={6} square>
        <Grid container justifyContent='center' alignContent='center'>
          <Grid item className={classes.paper}>
            <img src={logoImg} style={{ height: '13vh', marginBottom: '6vh' }} alt='umatch' />
            {!loading && (
              <>
                <form
                  onSubmit={e => {
                    e.preventDefault();
                    handleSignIn();
                  }}
                >
                  <TextField
                    onChange={handleChangeUser}
                    placeholder='Usuário'
                    type='text'
                    variant='outlined'
                    fullWidth
                    margin='normal'
                  />

                  <TextField
                    onChange={handleChangePassword}
                    placeholder='Senha'
                    type='password'
                    variant='outlined'
                    fullWidth
                  />
                  <Button
                    type='submit'
                    fullWidth
                    variant='contained'
                    color='primary'
                    className={classes.submit}
                    disabled={loading}
                  >
                    {loading ? 'Carregando...' : 'Entrar'}
                  </Button>
                </form>
                <Box mt={5}>
                  <Copyright />
                </Box>
              </>
            )}
            {loading && (
              <Grid item>
                <CircularProgress />
              </Grid>
            )}
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
}
